import { useMemo } from 'react';
import {
  resolveHelperText,
  resolveOptions,
  resolvePrompt,
  type AnswerOption,
  type OrgType,
  type Question,
  type QuestionnaireAnswers,
} from '@shared';

interface UseResolvedQuestionOptions {
  question: Question;
  answers: QuestionnaireAnswers;
  orgType: OrgType | null;
  organizationName: string | null;
}

export interface ResolvedQuestion {
  prompt: string;
  helperText: string | undefined;
  options: AnswerOption[];
}

export function useResolvedQuestion({
  question,
  answers,
  orgType,
  organizationName,
}: UseResolvedQuestionOptions): ResolvedQuestion {
  return useMemo(() => {
    const ctx = { answers, orgType, organizationName };

    return {
      prompt: resolvePrompt(question, ctx),
      helperText: resolveHelperText(question, ctx),
      options: resolveOptions(question, ctx),
    };
  }, [question, answers, orgType, organizationName]);
}
